import { action } from 'satcheljs';
export var onSharePointLinkDetected = action('ON_SHAREPOINT_LINK_DETECTED', function (linkId, sharingLinkIds, response, attachmentWellViewState, parentItemId, infoBarAddHandler, infoBarRemoveHandler) { return ({
    linkId: linkId,
    sharingLinkIds: sharingLinkIds,
    response: response,
    attachmentWellViewState: attachmentWellViewState,
    parentItemId: parentItemId,
    infoBarAddHandler: infoBarAddHandler,
    infoBarRemoveHandler: infoBarRemoveHandler,
}); });
//# sourceMappingURL=internalActions.js.map